import { StyleParamType, createStylesParams } from '@wix/tpa-settings';
import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';

import { IChallengeStyles } from './challengeStyles.types';

export const challengeStyles = createStylesParams<IChallengeStyles>({
  mobContentDividerWidth: {
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 4 },
      ai: {
        description: 'Width of content dividers on the mobile program page.',
      },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  mobChallengeNameSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 28 },
      ai: { description: 'Font size of the program name on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 28,
  },
  mobDateSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of the program date on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobPriceSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of the program price on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobSectionTitleSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 24 },
      ai: { description: 'Font size of section titles on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  mobCounterNumberSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program statistic values on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobCounterDescriptionSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program statistic labels on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobDescriptionSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program descriptions on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobButtonSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program action buttons on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobAgendaSectionTitleSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of agenda section titles on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobAgendaStepNameSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of agenda step names on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobAgendaLinkSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of agenda links on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobChallengeStatsFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program statistics on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobSidebarLayoutSidebarChallengeNameFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 24 },
      ai: {
        description: 'Font size of the program name in the mobile sidebar.',
      },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  mobSidebarLayoutSidebarSectionNameFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 18 },
      ai: { description: 'Font size of section names in the mobile sidebar.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 18,
  },
  mobSidebarLayoutSidebarStepNameFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of step names in the mobile sidebar.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobSidebarLayoutStepDescriptionFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: {
        description:
          'Font size of step descriptions in the mobile sidebar layout.',
      },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobSidebarLayoutBodyStepNameFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: {
        description: 'Font size of step names in the mobile program body.',
      },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobSidebarLayoutOverviewDescriptionFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of the overview description on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
});
